// Helper to generate country-specific route paths
import { CountryCode } from './countryConfig';

export const getCountryRoute = (countryCode: CountryCode, path: string): string => {
  const basePath = countryCode === 'RO' ? '' : `/${countryCode.toLowerCase()}`;
  return `${basePath}${path}`;
};

export const COUNTRY_ROUTES = {
  // Homepage
  home: (country: CountryCode) => getCountryRoute(country, '/'),
  
  // Vehicle listings
  vehicles: (country: CountryCode) => getCountryRoute(country, '/vehicles'),
  cars: (country: CountryCode) => getCountryRoute(country, '/cars'),
  
  // Dealers
  dealers: (country: CountryCode) => country === 'RO' 
    ? '/dealeri-verificati' 
    : getCountryRoute(country, '/verified-dealers'),
  
  // Legal pages
  terms: (country: CountryCode) => getCountryRoute(country, '/terms'),
  privacy: (country: CountryCode) => getCountryRoute(country, '/privacy'),
  
  // Support
  contact: (country: CountryCode) => getCountryRoute(country, '/contact'),
  faq: (country: CountryCode) => getCountryRoute(country, '/faq'),
  buyerGuide: (country: CountryCode) => getCountryRoute(country, '/ghid-cumparatori'),
  
  // Account
  auth: (country: CountryCode) => getCountryRoute(country, '/auth'),
  pricing: (country: CountryCode) => getCountryRoute(country, '/pricing'),
  dashboard: (country: CountryCode) => getCountryRoute(country, '/dashboard'),
  // dashboardListings kept as alias to myListingsV2 for backwards compatibility (consolidated)
  dashboardListings: (country: CountryCode) => getCountryRoute(country, '/my-listings-v2'),
  myListings: (country: CountryCode) => getCountryRoute(country, '/my-listings'),
  myListingsV2: (country: CountryCode) => getCountryRoute(country, '/my-listings-v2'),
  favorites: (country: CountryCode) => getCountryRoute(country, '/favorites'),
  myAlerts: (country: CountryCode) => getCountryRoute(country, '/my-alerts'),
  messages: (country: CountryCode) => getCountryRoute(country, '/messages'),
  compare: (country: CountryCode) => getCountryRoute(country, '/compare'),
  billing: (country: CountryCode) => getCountryRoute(country, '/dashboard/billing'),
  inventoryImport: (country: CountryCode) => getCountryRoute(country, '/dashboard/inventory/import'),
  dashboardStats: (country: CountryCode) => getCountryRoute(country, '/dashboard/statistici'),
  dashboardSettings: (country: CountryCode) => getCountryRoute(country, '/dashboard/setari'),
  
  // Content pages
  about: (country: CountryCode) => country === 'RO' 
    ? '/despre-noi' 
    : getCountryRoute(country, '/about'),
  howItWorks: (country: CountryCode) => country === 'RO'
    ? '/cum-functioneaza'
    : getCountryRoute(country, '/how-it-works'),
  dealerVerification: (country: CountryCode) => country === 'RO'
    ? '/proces-verificare-dealeri'
    : country === 'UK'
    ? getCountryRoute(country, '/dealer-verification-process')
    : getCountryRoute(country, '/handler-verifizierungsprozess'),
  whyUs: (country: CountryCode) => country === 'RO' 
    ? '/de-ce-noi' 
    : country === 'UK'
    ? getCountryRoute(country, '/why-us')
    : getCountryRoute(country, '/warum-wir'),
  citiesHub: (country: CountryCode) => country === 'RO'
    ? '/masini-orase'
    : country === 'UK'
    ? getCountryRoute(country, '/cities-hub')
    : getCountryRoute(country, '/stadte-hub'),
  autoStats: (country: CountryCode) => country === 'RO'
    ? '/statistici-auto-romania'
    : country === 'UK'
    ? getCountryRoute(country, '/auto-statistics')
    : getCountryRoute(country, '/auto-statistiken'),
  installApp: (country: CountryCode) => country === 'RO'
    ? '/instaleaza-aplicatia'
    : getCountryRoute(country, '/install'),
  seoAudit: (country: CountryCode) => getCountryRoute(country, '/seo-audit'),
  
  // Listing detail
  listing: (country: CountryCode, listingId: string) => 
    getCountryRoute(country, `/listing/${listingId}`),
  
  // Blog
  blog: (country: CountryCode, slug: string) => 
    getCountryRoute(country, `/blog/${slug}`),
  blogIndex: (country: CountryCode) => getCountryRoute(country, '/blog'),
  
  // Vehicle categories
  camioane: (country: CountryCode) => getCountryRoute(country, '/camioane'),
  motociclete: (country: CountryCode) => getCountryRoute(country, '/motociclete'),
  utilaje: (country: CountryCode) => getCountryRoute(country, '/utilaje'),
  ambarcatiuni: (country: CountryCode) => getCountryRoute(country, '/ambarcatiuni'),
  import: (country: CountryCode) => getCountryRoute(country, '/import'),
  
  // For dealers
  forDealers: (_country: CountryCode) => '/dealeri',
  demo: (country: CountryCode) => getCountryRoute(country, '/demo'),
  demoGratuit: (country: CountryCode) => getCountryRoute(country, '/demo-gratuit'),
  sell: (country: CountryCode) => getCountryRoute(country, '/create-listing-v2'),
  
  // Hub pages
  daciaHub: (country: CountryCode) => getCountryRoute(country, '/hub/dacia'),
  bmwHub: (country: CountryCode) => getCountryRoute(country, '/hub/bmw'),
  electricHub: (country: CountryCode) => getCountryRoute(country, '/hub/electric'),
  
  // Partners page for backlinks
  partners: (country: CountryCode) => country === 'RO' 
    ? '/parteneri' 
    : country === 'UK'
    ? getCountryRoute(country, '/partners')
    : getCountryRoute(country, '/partner'),
};
